export interface Loan {
  id: string
  name: string
  isin: string
  rating: string
  risk: string
  country: string
  currency: string
  amount: number
  description: string
  rate: string
  termMonths: number
  available: number
  fundedPct: number
}

export const loans: Loan[] = [
  {
    id: 'piranya',
    name: 'Piranya Software ApS',
    isin: 'LDKDKK000754951218',
    rating: 'C',
    risk: 'High',
    country: 'DK',
    currency: 'DKK',
    amount: 800000,
    description:
      'Der søges om midler til driftslikviditet for at imødekomme væksten i selskabet. Lånet blev faseopdelt i to udbud.',
    rate: '11,75%',
    termMonths: 48,
    available: 481773,
    fundedPct: 40,
  },
  {
    id: 'beachbum',
    name: 'Beachbum AS',
    isin: 'LNONOK000726275027',
    rating: 'C',
    risk: 'High',
    country: 'NO',
    currency: 'NOK',
    amount: 500000,
    description:
      'Selskapet søker om NOK 500.000 i likviditet til finansiering av videre drift. Lånet har en løpetid på 48 måneder.',
    rate: '13,50%',
    termMonths: 48,
    available: 277257,
    fundedPct: 45,
  },
]

export function formatAmount(value: number): string {
  return value.toLocaleString('da-DK')
}
